import http from './../../../base/api/public'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre
export default {
  getPage(params) {
    console.log(JSON.stringify(params))
    return http.requestPost(apiPre + service.order + '/order/chargingRequest/pagerListChargingRequestWithCondition', params)
  },
  getExceptionPage(params) {
    return http.requestPost(apiPre + service.order + '/order/chargingRequest/exceptionPagerList',params)
  },
  getDetail(params) {
    return http.requestGet(apiPre + service.order + '/order/chargingRequest/getOrderDetail/' + params, {})
  },
  getCardRechargePage(params) {
    return http.requestPost(apiPre + service.order + '/order/cardRecharge/pagerListWithCondition', params)
  },
  getPayOrderPage(params) {
    return http.requestPost(apiPre + service.order + '/order/payOrder/pagerListPayOrdersWithCondition', params)
  },
  getRefundOrderPage(params) {
    console.log(JSON.stringify(params))
    return http.requestPost(apiPre + service.order + '/order/refundOrder/pagerListWithCondition', params)
  },
  getDailyOrder(params) {
    console.log(JSON.stringify(params))
    return http.requestPost(apiPre + service.order + '/orderInfo/screen/dailyOrder', params)
  },
  getMonthlyOrder(params) {
    console.log(JSON.stringify(params))
    return http.requestPost(apiPre + service.order + '/orderInfo/screen/monthlyOrder', params)
  },
  getYearlyOrder(params) {
    console.log(JSON.stringify(params))
    return http.requestPost(apiPre + service.order + '/orderInfo/screen/yearlyOrder', params)
  },
  dailyOrderInfo() {
    return http.requestQuickGet(apiPre + service.order + '/orderInfo/screen/dailyOrderInfo')
  },
  monthlyOrderInfo() {
    return http.requestQuickGet(apiPre + service.order + '/orderInfo/screen/monthlyOrderInfo')
  },
  incomeOverview() {
    return http.requestQuickGet(apiPre + service.order + '/orderInfo/screen/incomeOverview')
  },
  operatorIncomeOverview(param) {
    return http.requestQuickGet(apiPre + service.order + '/orderInfo/screen/operatorIncomeOverview/' + param)
  },
  getOperatorDailyOrder(operatorId, params) {
    return http.requestPost(apiPre + service.order + '/orderInfo/screen/operatorDailyOrder/' + operatorId, params)
  },
  getOperatorMonthlyOrder(operatorId, params) {
    return http.requestPost(apiPre + service.order + '/orderInfo/screen/operatorMonthlyOrder/' + operatorId, params)
  },
  getOperatorYearlyOrder(operatorId, params) {
    return http.requestPost(apiPre + service.order + '/orderInfo/screen/operatorYearlyOrder/' + operatorId, params)
  },
  operatorDailyOrderInfo(param) {
    return http.requestQuickGet(apiPre + service.order + '/orderInfo/screen/operatorDailyOrderInfo/' + param)
  },
  operatorMonthlyOrderInfo(param) {
    return http.requestQuickGet(apiPre + service.order + '/orderInfo/screen/operatorMonthlyOrderInfo/' + param)
  },
  operatorList() {
    return http.requestQuickGet(apiPre + service.member + '/member/operator/operatorSelectionList')
  },
  /*执行手工结算接口*/
  handleSettlement(params){
    console.log(JSON.stringify(params))
    return http.requestPost(apiPre +service.sett + '/sett/settlementOrder/orderSett',params)
  },
  /*执行修复数据*/
  handleRepai(chargingNo){
    return http.requestQuickGet(apiPre +service.order + '/order/chargingRequest/repairChargingRequest/'+chargingNo)
  },

  /*执行分润*/
  executeProfitBehaviour(orderNo){
    return http.requestQuickGet(apiPre +service.order + '/order/chargingRequest/executeProfitBehaviour/'+orderNo)
  },

  // handleRefund(chargeOrderNo){
  //   return http.requestQuickGet(apiPre + service.sett + '/sett/settlementOrder/orderRefund/'+chargeOrderNo)
  // },
  handleRefund(param){
    return http.requestPost(apiPre + service.sett + '/sett/settlementOrder/orderRefund', param)
  },
  operatorToStation(){
    return http.requestQuickGet(apiPre+service.res + '/res/station/operatorToStation')
  },
  downloadRechargeOrder(param) {
    return http.requestDownloadExcel(apiPre + service.order + '/order/rechargeReport/reportOneSheet', param)
  },
  getReportColumns() {
    return http.requestQuickGet(apiPre+service.order + '/order/rechargeReport/reportColumns')
  },
  chargingNodeDetail(param) {
    return http.requestQuickGet(apiPre+service.order + '/order/chargingSettlement/chargingNodeDetail/'+param)
  },
  chargingSettlement(params) {
    return http.requestPost(apiPre + service.sett + '/sett/settlementOrder/chargingSettlement', params)
  },
  getTakeUpPileFeeRecordPage(params) {
    return http.requestPost(apiPre + service.order + '/order/takeUpPileFee/record/pagerList', params)
  },
  getTakeUpPileFeeDisputePage(params) {
    return http.requestPost(apiPre + service.order + '/order/takeUpPileFee/dispute/pagerList', params)
  },
  auditTakeUpPileFeeDispute(params) {
    return http.requestPost(apiPre + service.order + '/order/takeUpPileFee/dispute/audit', params)
  },



}



// WEBPACK FOOTER //
// ./src/module/possessionCenter/api/order.js